import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ContactInfo from 'modules/finance/components/Contacts/ContactInfo'
import GeneralInfo from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel/GeneralInfo'
import LegalEntityInfo from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel/LegalEntityInfo'
import PaymentInfo from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel/PaymentInfo'
import PurchaseRequestInfo from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel/PurchaseRequestInfo'
import { PurchaseOrder } from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetailPanel/types'

interface Props {
  purchaseOrder: PurchaseOrder
}

const FOOTER_OFFSET = 176

const Summary = ({ purchaseOrder }: Props) => {
  return (
    <Box
      gap="s40"
      padding="s24"
      overflowY="scroll"
      style={{
        height: `calc(100vh - ${FOOTER_OFFSET}px)`,
      }}
    >
      <GeneralInfo purchaseOrder={purchaseOrder} />
      <Box gap="s12">
        <Text weight="bold" size="200" color="grey800" caps>
          {i18n.t('procurement.purchase_orders.detail.vendor.title')}
        </Text>
        <ContactInfo
          contact={purchaseOrder?.vendor ?? undefined}
          editable
          showBankAccountInfo
          as={'vendor'}
        />
      </Box>
      {purchaseOrder.preferredPaymentMethod && <PaymentInfo purchaseOrder={purchaseOrder} />}
      <LegalEntityInfo legalEntity={purchaseOrder.legalEntity} />
      {purchaseOrder.purchaseRequest && (
        <PurchaseRequestInfo purchaseRequest={purchaseOrder.purchaseRequest} />
      )}
    </Box>
  )
}

export default Summary
